module.exports = __webpack_public_path__ + "static/media/imagem18.bf4824d3.jpeg";